@import '../../../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.manage-locations-container {
  padding-top: @space-20;

  > .row {
    justify-content: space-between;
    align-items: center;
  }
}

.add-location-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: @space-4;

  > .button-icon {
    width: 16px;
    height: 16px;
  }
  > .button-text {
    text-wrap: nowrap;
  }
}

.table-actions {
  place-items: center flex-end;
  justify-content: space-between;
}

.buttons {
  gap: @space-16;
  margin-top: @space-16;
}
